import type { Vec3 } from '../../geo/types';
import { starboardSection, type HullStation } from './hull';

/** An open boat's shell thickness, plank and gunwale together, as the quay sees it across the cap. */
export const OPEN_BOAT_SHELL = 0.06;

/** The hold's floor at a station: the lowest section row, over the keel and bottom boards. */
export function floorHeight(st: HullStation): number {
  return starboardSection(st)[1]![1];
}

/** The inside of an open boat's shell at a station, from the gunwale down the starboard side to
    the floor. */
export function innerStarboard(st: HullStation): Vec3[] {
  const [, ...rows] = starboardSection(st);
  return rows.map(([x, y, z]): Vec3 => [x, y, Math.max(z - OPEN_BOAT_SHELL, 0)]).reverse();
}
